export const appendString = (
	value: string,
	appendValue: string,
	forceAppend = true,
) => {
	return value.concat(
		!value.endsWith(appendValue) || forceAppend ? appendValue : "",
	);
};
